import { useState } from "preact/hooks";
import { JSX } from "preact/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Navigation } from "../../components";
import { Image, PageContainer } from "../../shared/ui";
import css from "./Language.module.scss";

type Locale = "en" | "ru";

interface LanguageOption {
  code: Locale;
  translationKey: string;
  nativeName: string;
  englishName: string;
}

const languages: LanguageOption[] = [
  {
    code: "en",
    translationKey: "language.languages.en",
    nativeName: "English",
    englishName: "English",
  },
  {
    code: "ru",
    translationKey: "language.languages.ru",
    nativeName: "Русский",
    englishName: "Russian",
  },
];

export const Language = () => {
  const { t, i18n } = useTranslation();
  const locale = (i18n.language as Locale) || ("en" as Locale);
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (e: JSX.TargetedEvent<HTMLInputElement>) => {
    setSearchQuery(e.currentTarget.value);
  };
  const filteredLanguages = languages.filter((lang) => {
    return lang.nativeName.toLowerCase().includes(searchQuery.toLowerCase());
  });

  const handleLanguageSelect = (languageCode: Locale) => {
    i18n.changeLanguage(languageCode);
  };

  return (
    <div>
      <Navigation title={t("language.title")} />

      <PageContainer>
        <div className={css.searchContainer}>
          <div className={css.searchInputWrapper}>
            <Image src="search.png" variant="base" className={css.searchIcon} />
            <input
              type="text"
              placeholder={t("language.search_placeholder")}
              value={searchQuery}
              onInput={handleSearch}
              className={css.searchInput}
            />
          </div>

          <div className={css.languageList}>
            {filteredLanguages.map((language) => (
              <button
                key={language.code}
                className={`${css.languageItem} ${
                  locale === language.code ? css.selected : ""
                }`}
                onClick={() => handleLanguageSelect(language.code)}
              >
                <span className={css.languageName}>{language.nativeName}</span>
              </button>
            ))}
          </div>
        </div>
      </PageContainer>
    </div>
  );
};
